import { render, staticRenderFns } from "./HomeEditorialProjectCard.vue?vue&type=template&id=1acc6a11"
import script from "./HomeEditorialProjectCard.vue?vue&type=script&lang=js"
export * from "./HomeEditorialProjectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports